import {
  ADD_FORGOT_PASSWORD_FIELD_ERROR,
  CHANGE_FORGOT_PASSWORD_FORM_FIELD,
  CLEAR_FORGOT_PASSWORD_FIELD_ERROR,
  FORGOT_PASSWORD_REQUEST,
  FORGOT_PASSWORD_REQUEST_FAILURE,
  FORGOT_PASSWORD_REQUEST_SUCCESS,
} from './actions'

export const initialState = () => {
  return {
    formData: {
      email: '',
    },
    resetEmailSend: false,
    errors: {},
    loading: false,
  }
}

export default function reducer(state = initialState(), action) {
  switch (action.type) {
    case CHANGE_FORGOT_PASSWORD_FORM_FIELD:
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.payload.key]: action.payload.value,
        },
      }

    case FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        errors: {},
      }

    case FORGOT_PASSWORD_REQUEST_SUCCESS:
      return {
        ...state,
        resetEmailSend: true,
        loading: false,
      }

    case FORGOT_PASSWORD_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.errors,
      }

    case ADD_FORGOT_PASSWORD_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: action.payload.error,
        },
      }

    case CLEAR_FORGOT_PASSWORD_FIELD_ERROR:
      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.field]: undefined,
        },
      }

    default:
      return state
  }
}
